import * as React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { createStyles, makeStyles, Theme } from '../../../themes/ThemeProvider'
import {
  KeyboardDatePicker,
  KeyboardDatePickerProps as MuiKeyboardDatePickerProps
} from '../../atom/Pickers'

type ReactHookDatePickerProps = {
  name: string,
  formContext?: any
}

export type FormDatePickerProps = ReactHookDatePickerProps &
  Omit<MuiKeyboardDatePickerProps, 'value' | 'onChange'>

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2.5)
    },
    MuiFormHelperTextContained: {
      marginLeft: 0,
      position: 'absolute',
      bottom: theme.spacing(-2.5)
    }
  })
)

export const FormDatePicker: React.FC<FormDatePickerProps> = (props) => {
  const classes = useStyles(props)
  const { formContext, name, label, defaultValue, ...rest } = props
  const formContextLocal = useFormContext()

  const { control, errors } = formContext || formContextLocal
  const formHelperTextProps = {
    classes: {
      contained: classes.MuiFormHelperTextContained
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? null}
      render={({ onChange, value }) => {
        return (
          <KeyboardDatePicker
            autoOk
            value={value}
            label={label ? label : undefined}
            {...rest}
            onChange={onChange}
            inputProps={{ 'data-testid': name }}
            fullWidth
            variant="inline"
            InputAdornmentProps={{ position: 'end' }}
            helperText={errors[`${name}`]?.message}
            error={!!errors[`${name}`]}
            FormHelperTextProps={formHelperTextProps}
            className={classes.root}
          />
        )
      }}
    />
  )
}
